import { useState } from 'react';
import { useNavigate } from 'react-router';
import { DropdownMenu, DropdownMenuContent } from '@/components/ui/dropdown-menu';
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { isPreStart } from 'helpers/experiment-status';
import { ActionModals, type ActionModalsTypes } from './ActionModals';
import { Button } from '@/components/ui/button';
import { MoreHorizontal } from 'lucide-react';

type RowActionsProps = {
  experiment: any;
  /** Set on the first row only, for the product tour. */
  tourAnchor?: string;
};

export const ActionsCell = ({ experiment, tourAnchor }: RowActionsProps) => {
  const { id } = experiment;
  const [dialogAction, setDialogAction] = useState<ActionModalsTypes | null>(null);
  const navigate = useNavigate();
  const canDelete = isPreStart(experiment.status);
  const canArchive = experiment.status === 'Ended';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="h-8 w-8 p-0" data-tour={tourAnchor}>
          <span className="sr-only">Open actions</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => navigate(`/experiments/${id}`)}>View</DropdownMenuItem>
        <DropdownMenuItem onClick={() => setDialogAction('duplicate')}>Duplicate</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => setDialogAction('archive')} disabled={!canArchive}>
          Archive
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setDialogAction('delete')} disabled={!canDelete}>
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
      {dialogAction && (
        <ActionModals
          experiment={experiment}
          dialogAction={dialogAction}
          setDialogAction={setDialogAction}
          onClose={() => setDialogAction(null)}
        />
      )}
    </DropdownMenu>
  );
};
